import { render } from "./RegisterIndex.vue?vue&type=template&id=dddb7434&scoped=true"
import script from "./RegisterIndex.vue?vue&type=script&lang=js"
export * from "./RegisterIndex.vue?vue&type=script&lang=js"

import "./RegisterIndex.vue?vue&type=style&index=0&id=dddb7434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dddb7434"]])

export default __exports__